import { z } from 'zod';

import { LiquidationRecordInput } from '../loan/LiquidationRecord';
import { BaseLoanEvent } from './BaseLoanEvent';

export const RecordLiquidationEvent = BaseLoanEvent.extend({
  type: z.literal('recordLiquidation'),
  input: LiquidationRecordInput,
});
export type RecordLiquidationEvent = z.infer<typeof RecordLiquidationEvent>;
